import { styled, Typography } from '@mui/material';
import { OfferNoteBlock } from 'pages/candidateOffer/components';
import { useTranslation } from 'react-i18next';

export default function NoteForConsultant() {
    const { t } = useTranslation('candidateOffers');

    return (
        <Root>
            <Typography variant="body2"
                fontWeight="medium"
                color="text.primary"
                gutterBottom
            >
                { t('replyCommentHeading') }
            </Typography>
            <NoteWrapper>
                <OfferNoteBlock />
            </NoteWrapper>
        </Root>
    );
}

const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
});

const NoteWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
});
